import styled from '@emotion/styled';

import { Button } from 'components/buttons';

export const PanelTitle = styled.span((props) => ({
  display: 'inline-flex',
  fontSize: 16,
  fontWeight: 500,
  color: props.theme.colors.primary,
  fontFamily: props.theme.fonts.primary,
}));

export const CloseButton = styled(Button)(() => ({
  padding: 4,
  minWidth: 'unset',
}));

export const Body = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  minWidth: 360,
  maxWidth: 420,
  padding: '5px 10px 20px 10px',
}));
